import { graphql } from '../../graphql/generated';

export const PROFILES_QUERY = graphql(`
  query Profiles($doctorId: ID!) {
    profiles(doctorId: $doctorId) {
      id
      name
      hotKey
      parameters {
        id
        parameter {
          id
          shortName
          longName
          lab {
            id
            shortName
          }
        }
        preferredBillingType
      }
      diagnoses {
        id
        text
        lab {
          id
          shortName
        }
      }
      diagnose
    }

    catalogParameters(doctorId: $doctorId) {
      id
      parameter {
        id
        shortName
        longName
        lab {
          id
          shortName
        }
        synonyms
      }
    }

    diagnoses(doctorId: $doctorId) {
      id
      text
      lab {
        id
        shortName
      }
    }

    doctorsForCurrentUser {
      id
      name
      meAddress
      firstName
      lastName
      postTitle
      preTitle
      salutation
      disabled
    }

    doctor(id: $doctorId) {
      id
      flipParamNames
    }
  }
`);

export const DELETE_PROFILE_MUTATION = graphql(`
  mutation DeleteProfile($id: ID!) {
    deleteProfile(id: $id)
  }
`);
